import { render } from "./PurposeQuickCreateModal.vue?vue&type=template&id=0f23c402&scoped=true"
import script from "./PurposeQuickCreateModal.vue?vue&type=script&lang=js"
export * from "./PurposeQuickCreateModal.vue?vue&type=script&lang=js"

import "./PurposeQuickCreateModal.vue?vue&type=style&index=0&id=0f23c402&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f23c402"]])

export default __exports__